module.exports = __webpack_public_path__ + "img/wireframe_start_crystal.08d74d1b.jpg";